export class ProdutoIdadeEmprestimo {
  public idadeMaxima!: number;
  public prazoMaximo!: number;
  public valorMaximoContratado!: number;
  public valorMinSaldoDevedor!: number;
  public valorMaxSaldoDevedor!: number;
}